const getConnectionLostTimeout = () => (_, getState) => {
  const state = getState();
  return state.preferences.connectionLostTimeout;
};

export default getConnectionLostTimeout;
